import { HTTPAUTH } from "../lib/httplib"

const state = {
  products: []
}

const mutations = {
  set_products (state, products) {
    state.products = products
  },
}

const actions = {
  product_get_active (context, q) {
    HTTPAUTH.get(`/api/v1/search/product/active?size=10&${q}`)
      .then((resp) => {
        context.commit('set_products', resp.data.data)
      });
  },
}

const getters = {
}

export default {
  state, getters, mutations, actions
}